import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { IProduct } from 'reactApp/modules/products/products.types';
import { Product } from 'reactApp/types/Billing';
import { ACTIONS_DEFS } from 'reactApp/ui/TariffsSection/TariffSection.constants';
import { getMonthes, isMonthPeriod, isYearPeriod } from 'reactApp/utils/Period';

import { TABS_MAP } from './MobileSubscriptionsPage.constants';
import { ITariffsMobile, TabValue } from './MobileSubscriptionsPage.types';

export const getActiveTab = (hash: string) => {
    const tabs = Object.fromEntries(Object.entries(TABS_MAP).map(([k, v]) => [v, k as TabValue]));
    return tabs[hash] || tabs[TABS_MAP.special];
};

export const getAvailableHash = (hash: string, marketingPromo?: typeof ACTIONS_DEFS['marketingPromo']) => {
    if (hash) {
        return hash;
    }

    return marketingPromo ? TABS_MAP.special : TABS_MAP.usual;
};

export const normalizeMobileTariffList = (productsBySpace: Record<number, [Product, Product | undefined]>): ITariffsMobile[] => {
    return Object.entries(productsBySpace).map(([bytes, product]) => {
        const space = bytesToNDigits(Number(bytes), 3);
        const countSnapshotsBySpace = Math.round(Number(bytes) / (3.5 * 1024 * 1024));
        const monthProduct = product.find((p) => p?.period && isMonthPeriod(p.period));
        const yearProduct = product.find((p) => p?.period && isYearPeriod(p.period));
        const hasOldPriceYear = Boolean(yearProduct?.discountPrice);
        let saving;
        if (yearProduct && yearProduct?.discountPrice) {
            saving = Math.round(((yearProduct?.price - yearProduct.discountPrice) / yearProduct?.price) * 100);
        } else if (yearProduct && monthProduct) {
            saving = Math.round((1 - yearProduct.price / (getMonthes(yearProduct.period) * monthProduct.price)) * 100);
        }

        return {
            space,
            oldPrice: yearProduct?.price,
            hasOldPriceYear,
            fullPrice: yearProduct?.price,
            countSnapshotsBySpace,
            isBase: product.some((p) => p?.isBase),
            products: [
                monthProduct,
                {
                    saving,
                    primary: true,
                    ...yearProduct,
                },
            ].filter(Boolean) as IProduct[],
        };
    });
};
